import React from 'react';
import Footer from '../components/footer';
import phoneIcon from '../assets/images/phoneIcon.svg';
import '../styling/containerStyles.css'

interface ErrorMessageProps{
    addClass?:string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = (props: ErrorMessageProps) =>{
    const { addClass } = props;
        return (
            addClass == 'app5' ?
            <div className="App"> 
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>Only painter token allowed.</h2>
                    </div>
                </div>
                <Footer />
            </div>
            </div>
            :
            addClass == 'app3' ?
            <div className="App"> 
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>Your KYC has been rejected. Kindly contact the customer support at&nbsp;
                            <div className='rightText customer_care'><a href="tel:9223192020">
                                <img src={phoneIcon} alt='Phone Icon' className='phoneIcon' />
                                9223192020</a></div>
                            &nbsp;and press option ‘4’ for Haisha program for further assistance</h2>
                    </div>  
                </div>
                <Footer />
            </div>
            </div>
            :
            addClass == 'app2' ?
            <div className="App"> 
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>This code is not valid for your user type.</h2>
                    </div>
                </div>
                <Footer />
            </div>
            </div>
            :
            addClass == 'App1' ? 
            <div className="App"> 
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>You are not eligble for this couponcode</h2>
                    </div>
                </div>
                <Footer />
            </div>
            </div>
            :
            addClass ?
            <div className="App"> 
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>Something went wrong please try again</h2>
                    </div>
                </div>
                <Footer />
            </div>
            </div>
            :
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>Something went wrong please try again</h2>
                    </div>
                </div>
                <Footer />
            </div>  
        )
    }

export default ErrorMessage;